<template>
  <div id="footer" class="container-fluid">
    <div class="container container-fuild">
      <div class="col col-xs-12 col-sm-6 col-md-3">
        <div class="logo">
          <img src="@/assets/img/logo_hyaline.png" alt="logo图">
          <div class="logo-text">
            <p class="text-name">自动化MES管理系统</p>
            <p class="text">MES ADMIN LOGIN</p>
          </div>
        </div>
      </div>
      <div class="col col-xs-12 col-sm-6 col-md-6">
        <div class="companyView">
          <!-- <p class="company text-left">江苏德木供应链管理有限公司</p> -->
          <p class="copy text-left">Copyright &copy; @2021江苏德木供应链管理有限公司</p>
          <p class="text text-left">
            苏ICP备18028199号-3
            <img class="img" src="https://dm-auto.oss-cn-shanghai.aliyuncs.com/mes-login/jinghui.png" alt="">
            苏公网安备32058502010938号
          </p>
        </div>
      </div>
      <div class="col col-xs-12 col-sm-6 col-md-3">
        <div class="aboutView">
          <p class="about-text text-left">关于德木</p>
          <p class="service text-left">联系客服</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: "Footer",
    data() {
      return {};
    }
  };
</script>
<style scoped>
  #footer {
    width: 100%;
    height: 100%;
    color: #fff;
    background: #474747;
    overflow: hidden;
    text-align: center;
    padding: 40px 0 80px 0;
  }

  .logo {
    display: flex;
    margin-bottom: 10px;
  }

  .logo img {
    width: 50px;
    height: 45px;
  }

  .logo .logo-text {
    margin-left: 15px;
  }

  .logo .logo-text .text-name {
    font-size: 16px;
    font-weight: 400;
    margin-bottom: 3px;
  }

  .logo .logo-text .text {
    font-size: 14px;
    font-weight: 400;
  }

  .logo p {
    margin: 0;
    text-align: left;
  }

  .companyView .company {
    font-weight: 500;
    font-size: 18px;
    margin-bottom: 20px;
  }

  .companyView .text {
    display: flex;
    align-items: center;
  }

  .companyView .text .img {
    margin: 0 5px;
  }

  .aboutView .about-text {
    font-weight: 500;
    font-size: 18px;
    margin-bottom: 20px;
  }

  @media screen and (max-width: 997px) {}
</style>


// WEBPACK FOOTER //
// src/components/Footer.vue